import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import applyFormat from '../functions/applyFormat';
import DynamicPageInput from './DynamicPageInputCopy.jsx'; 
import PageInput from './PageInputCopy.jsx'; 
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import CCOffcanvas from './CCOffcanvas.tsx';

const EditAdhocPaymentModal = ({ refreshFunction }) => {
    // initialize PageContext
    const {
        showEditAdhocModal,
        setShowEditAdhocModal,
        editAdhocRow,
        snackbarAlert, 
        adhocInputConfig, 
        adhocInputLists
    } = useContext(PageContext);
    // initialize HttpContext
    const {
        PUT,
    } = useContext(HttpContext);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]); 

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let response; 

            // let path = '/data/adhoc/adhocpage'; 
            // let args = {
            //     paymentid: editAdhocRow['paymentid'],
            //     mastercompanyid: masterCompanyId,
            //     companyid: subCompany,
            //     amount: amount.replaceAll(",", ""),
            //     active: active,
            // }; 

            // validate input 
            let requestValues = [{...values}]; 
            console.log('BEFORE: ', requestValues); 
            let checkError = validateInputArray(
                requestValues, 
                adhocInputConfig, 
                dynamicValidation, 
                adhocInputLists, 
                snackbarAlert, 
                error, 
                setError, 
                dynamicTransformation, 
                {}
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }
            console.log('AFTER: ', requestValues); 
            // specify path and args 
            let path = '/workflow/adhoc'; 
            let args = {
                editAdhocRow: editAdhocRow['mastercompanyid'], 
                paymentid: editAdhocRow['paymentid'], 
                ...requestValues[0]
            }
            // make request 
            PUT(path, args).then(res => {
                console.log(res);
                response = res;
                // hide modal 
                setShowEditAdhocModal(showEditAdhocModal => showEditAdhocModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh data on page
                return refreshFunction();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }


    // useEffect to run on config change 
    useEffect(() => {
        if (adhocInputConfig){
            setConfig(config => config = adhocInputConfig); 
        }
    }, [adhocInputConfig]); 

    // useEffect to run on editAdhocRow change
    useEffect(() => {
        if (editAdhocRow) {
            console.log(editAdhocRow); 
            // add ids to lookup values 
            let temp = {
                ...editAdhocRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, adhocInputConfig, adhocInputLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editAdhocRow]); 

    return (
        <>
            <CCOffcanvas
                show={showEditAdhocModal}
                title='Edit Ad-Hoc Payment'
                onCanvasClose={() => setShowEditAdhocModal(showEditAdhocModal => showEditAdhocModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName='offcanvas-parent-card-30'
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                        <div className="d-flex align-items-center justify-content-start">
                            <PageInput 
                                tag='Company ID'
                                value={editAdhocRow['companyid']}
                                disableEdit={true}
                                topAlignTypography={true}
                            />
                        </div>
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) => 
                            el['edit'] == true ?
                                <div className="d-flex align-items-center justify-content-start mt-3">
                                    <DynamicPageInput 
                                        data={values} 
                                        setData={setValues} 
                                        config={el} 
                                        args={adhocInputLists} 
                                        width={'100%'} 
                                        showError={error[0][el['columnid']]}
                                        topAlignTypography={'true'}
                                    />
                            </div>
                            : <></>
                        )}                    
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditAdhocPaymentModal;